
import VideoOctagon from "../../../assets/filled/VideoOctagon.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function VideoOctagonIcon({ className, dataTestid = "VideoOctagonIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <VideoOctagon data-testid={dataTestid} className={classes} {...rest} />
  );
}
